import { observable, action } from 'mobx'
class MapStore {
  @observable currentPosition = null
  @observable needCenter = false
  @observable currentLng = null
  @observable currentLat = null
  @observable currentCountry = null
}
const store = new MapStore()
export default store



// WEBPACK FOOTER //
// ./src/store/MapStore.js